<template>
<v-app>
  <v-content>
  <v-container fluid ma-0 pa-0 v-resize="onResize">
    <v-img src="../../static/img/background_small.jpg" :width="x" :height="y" class="bgimage">
        <nav class="navbar navbar-light" style="height: 10px;">
          <a class="navbar-brand" href="#">
            <img src="../assets/img/logo.png" width="60" height="40" class="d-inline-block align-top" alt="">
            <div style="display: inline-block; padding-left: 5px; color: white;font-weight: 700;">
              <span> KENYA COFFEE </span>
            </div>
          </a>
          <div id="navbarNav" style="margin-right: 200px;">
          <ul class="nav justify-content-end">
            <li class="nav-item">
              <router-link class="nav-link links" to="/">Home</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://onlinebanking.co-opbank.co.ke/" target="_blank">Co-op Online</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.nairobicoffeeexchange.co.ke/" target="_blank">NCE</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.agricultureauthority.go.ke/" target="_blank">AFA</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.cma.or.ke/" target="_blank">CMA</a>
            </li>
            <li class="nav-item">
              <router-link class="nav-link links active" to="/contactus">Contact Us</router-link>
            </li>
          </ul>
        </div>
        </nav>
      <v-layout align-center row  fill-height wrap>
        <v-flex xs4 offset-xs5 class="loginfront">
          <h3 class="white--text loginhead"> Login </h3>
          <v-flex v-if="response">
           <p class="loginresponse">{{response}}</p>
          </v-flex>
          <v-form>
            <div class="wrap-input100" style="margin-bottom: 40px;">
              <input class="input100" type="text" name="email" v-model="username" v-on:blur="blurEmail" @keyup.enter="checkCreds" :class="removeUsernameLabel === true ? 'has-val' : ''">
              <span class="focus-input100"></span>
              <span class="label-input100">Email</span>
            </div>

            <div class="wrap-input100 validate-input" data-validate="Password is required" style="margin-bottom: 40px;">
              <input class="input100" type="password" name="pass" v-model="password" v-on:blur="blurPassword" @keyup.enter="checkCreds" :class="removePassLabel === true ? 'has-val' : ''">
              <span class="focus-input100"></span>
              <span class="label-input100">Password</span>
            </div>
          </v-form>
          <div class="logindiv">
              <router-link mt-5 class="pageLink white--text" to="/user/resetpassword"> Forgot Password?  </router-link>
              <v-btn type="button" class="btn loginbtn primary--text" @click="handleLogin" :loading="loading"> Login </v-btn>

          </div>
        </v-flex>
      </v-layout>
    </v-img>
  </v-container>
</v-content>
</v-app>
</template>
<script>
import axios from 'axios'
import config from '../config'
import store from '../store'
import CryptoJS from 'crypto-js'
export default {
	name: 'Login',
	data (router) {
		return {
			section: 'Login',
			loading: false,
			username: '',
			password: '',
			response: '',
			message: '',
			snackbar: false,
			snackbarNetwork: false,
			networkMessage: '',
			x: 0,
			y: 0,
			removeUsernameLabel: false,
			removePassLabel: false
		}
	},
	mounted () {
		var urlString = window.location.href
		var url = new URL(urlString)
		var message = url.searchParams.get('message')
		this.message = message
		this.onResize()
	},
	watch: {
		networkError: function (val) {
			console.log(val)
			if (val) {
				this.snackbarNetwork = true
				this.networkMessage = 'Connection error: Server Unreachable'
			}
		}
	},
	computed: {
		networkError: function () {
			return store.state.networkError
		}
	},
	methods: {
		onResize () {
			this.x = window.innerWidth
			this.y = window.innerHeight
		},
		handleLogin (event) {
			// Prevent any default behavior
			if (event) {
				event.preventDefault()
				event.stopPropagation()
			}
			this.checkCreds()
		},
    encryptPassword(password) {
      const secretKey = process.env.VUE_APP_SECRET_KEY
      console.log('secretKey - ', secretKey)
      const encrypted = CryptoJS.AES.encrypt(password, secretKey).toString();
      return encrypted;
    },
    checkCreds () {
      this.message = ''
      this.resetResponse()
      var url = config.serverURI + '/token/generate-token'
      this.loading = true
      let encryptedUsername = this.encryptPassword(this.username.trim());
      let encryptedPassword = this.encryptPassword(this.password.trim());
      axios
        // .post(url, { username: this.username.trim(), password: this.password, multifactor: config.multifactorAuthOn })
        .post(url, { username: encryptedUsername, password: encryptedPassword, multifactor: config.multifactorAuthOn })
        .then(response => {
          var data = response.data
          console.log("error==========")

          /* Checking if error object was returned from the server */
          if (data.error) {
            var errorName = data.error
            if (errorName) {
              if (errorName === 'Bad credentials') {
                this.response = 'Invalid username or password'
              } else if (errorName.includes('locked')) {
                this.response = 'Too many login attempts. Please contact support if you need assistance.'
              } else {
                this.response = errorName
              }
            } else {
              this.response = errorName
            }
            console.log(this.response)
            this.loading = false
            return
          }

          	if (config.multifactorAuthOn) {
							// when multifactor auth is on and user not an internal user
							// this.$store.commit('SET_TEMP_TOKEN', token)
							this.$router.push(data.userId + '/login/otp-validate')
							// this.$router.push(data.user.id + '/otp-validate')
						}else{
              		if (data.token) {
						this.username = ''
						this.password = ''
						var token = 'Bearer ' + data.token
					
							this.$store.commit('SET_USER', data.user)
							this.$store.commit('SET_TOKEN', token)
							if (window.localStorage) {
								window.localStorage.setItem('user', JSON.stringify(data.user))
								window.localStorage.setItem('token', token)
								window.localStorage.setItem('refreshToken', data.refreshToken)
							}
							// this.$router.push(data.redirect ? data.redirect : '/dashboard')
							this.$router.push('/dashboard')
						
						this.loading = false
					}
            }

          /* Setting user in the state and caching record to the localStorage */
					if (data.token) {
						this.username = ''
						this.password = ''
						var token = 'Bearer ' + data.token
						if (config.multifactorAuthOn) {
							// when multifactor auth is on and user not an internal user
							// this.$store.commit('SET_TEMP_TOKEN', token)
							this.$router.push(data.userId + '/login/otp-validate')
							// this.$router.push(data.user.id + '/otp-validate')
						} else {
							this.$store.commit('SET_USER', data.user)
							this.$store.commit('SET_TOKEN', token)
							if (window.localStorage) {
								window.localStorage.setItem('user', JSON.stringify(data.user))
								window.localStorage.setItem('token', token)
								window.localStorage.setItem('refreshToken', data.refreshToken)
							}
							// this.$router.push(data.redirect ? data.redirect : '/dashboard')
							this.$router.push('/dashboard')
						}
						this.loading = false
					}
				})
				.catch(error => {
					this.$store.commit('TOGGLE_LOADING')
					console.log(error)

					this.response = 'Authentication error'
					this.loading = false
				})
		},
		resetResponse () {
			this.response = ''
		},
		blurEmail () {
			if (this.username === '') {
				this.removeUsernameLabel = false
			} else {
				this.removeUsernameLabel = true
			}
		},
		blurPassword () {
			if (this.password === '') {
				this.removePassLabel = false
			} else {
				this.removePassLabel = true
			}
		}
	}
}

</script>
<style scoped>
.labelstyle >>> .v-text-field__slot label {
    color: white;
    font-weight: 300px !important;
    font-family: 'Open Sans', sans-serif;
}

.inputstyle >>> .v-text-field__slot input {
    color: white;
    font-family: 'Open Sans', sans-serif;
    font-size: 20px;
}

.loginresponse {
  color: red;
  font-weight: 600;
}

.header {
  font-size: 20px;
  font-weight: 700;
  color: white;
  padding-top: 15px
}

.headermotto {
  font-size: 16px;
  font-weight: 500;
  color: white;
}
.logintext {
  font-size: 20px;
  font-weight: 700;
  color: white;
  padding-top: 15px
}
.loginbtn {
  font-weight: bold;
  text-transform: capitalize;
  border-radius: 5px 5px 5px 5px;
  float: right;
  background-color: #B2CCC4 !important;
  width: 100px;
  border-color: #FFF;
}

.footer {
  background: #000000B2 0% 0% no-repeat padding-box;
  opacity: 0.7;
  height: 50px;
}

.loginfront {
  background: #000000B2 0% 0% no-repeat padding-box;
  padding-left: 40px;
}
.logindiv {
  margin: 0;
  width: 80%;
  margin-bottom: 20px;
  height: 50px;
  text-align: justify;
}
.pageLink {
  font-size: 14px;
  padding-top:10px;
  font-style: "Brandon Grotesque";
}
.loginhead {
  font-size: 14px;
  font-weight: 700;
  font-style: "Brandon Grotesque";
  margin-top:30px;
  margin-bottom:20px;
}
.links {
  padding-left: 30px;
  padding-right: 30px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  font-style:"Brandon Grotesque";
}
.active {
  width: 150px;
  background-color: #7BC243;
  text-align: center;
  border-radius: 5px 5px 5px 5px;
}
</style>
